// src/admin/components/HistoryModal.js
import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

export default function HistoryModal({ item, onClose }) {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('access_token');

  const fetchMovements = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/restaurant_ingredients/${item.id}`;
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) {
        throw new Error('Errore nel recupero dei movimenti');
      }
      const data = await res.json();
      setMovements(data.movements || []);
    } catch (error) {
      console.error('HistoryModal fetchMovements error:', error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMovements();
    // eslint-disable-next-line
  }, [item.id]);

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>Storico Movimenti</h2>
        <p style={styles.infoLine}>
          Prodotto: <strong>{item.ingredient_name}</strong> (ID: {item.id})
        </p>
        {loading ? (
          <p>Caricamento...</p>
        ) : movements.length === 0 ? (
          <p>Nessun movimento registrato.</p>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Data</th>
                <th style={styles.th}>Variazione</th>
                <th style={styles.th}>Prezzo Unit.</th>
                <th style={styles.th}>Motivo</th>
              </tr>
            </thead>
            <tbody>
              {movements.map((mv) => {
                const date = new Date(mv.timestamp).toLocaleString();
                const change = parseFloat(mv.quantity_change).toFixed(2);
                const cpu =
                  mv.cost_per_unit !== null
                    ? parseFloat(mv.cost_per_unit).toFixed(2)
                    : '—';

                const changeStyle = {
                  color: mv.quantity_change >= 0 ? 'green' : 'red',
                };

                return (
                  <tr key={mv.id} style={styles.tr}>
                    <td style={styles.td}>{date}</td>
                    <td style={{ ...styles.td, ...changeStyle }}>
                      {mv.quantity_change >= 0 ? `+${change}` : change}
                    </td>
                    <td style={styles.td}>{cpu}</td>
                    <td style={styles.td}>{mv.reason || '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        <div style={styles.buttonRow}>
          <button style={styles.closeBtn} onClick={onClose}>
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.4)', // Overlay
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    backgroundColor: '#FFFFFF',
    padding: '20px',
    borderRadius: '8px',
    width: '600px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
  },
  title: {
    marginTop: 0,
    marginBottom: '10px',
    color: '#333',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  infoLine: {
    margin: '0 0 10px 0',
    color: '#333',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
    border: '1px solid #EEE',
    textAlign: 'left',
    fontSize: '0.9rem',
  },
  th: {
    padding: '8px',
    borderBottom: '2px solid #EEE',
    color: '#333',
    fontWeight: 'bold',
  },
  tr: {
    borderBottom: '1px solid #EEE',
  },
  td: {
    padding: '8px',
    color: '#333',
  },
  buttonRow: {
    textAlign: 'right',
    marginTop: '20px',
  },
  closeBtn: {
    backgroundColor: '#333',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    color: '#fff',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
};
